import React, { useRef } from "react";
import { Menu } from "primereact/menu";
import useCensus from "../../hooks/useCensus";
import useActionMenuServices from "../../hooks/useActionMenuServices";
import _ from 'lodash'

const ProCensusActionMenu = ({data = null, performAction, multipleActive})=>{   
    const {data:{filter}} = useCensus({ refreshTree: false })   
    const {actions:{GetCensusMenuItems}} = useActionMenuServices({performAction})
    const menuRef = useRef(null)
   
    return <div>
        <i className="pi pi-ellipsis-h" onClick={(event) => menuRef && menuRef.current.toggle(event)} style={{ position: 'relative', top: 2 }}></i> 
        <Menu  model={GetCensusMenuItems(data, filter, multipleActive)} popup ref={menuRef} />
    </div>
    
}

export default ProCensusActionMenu;